// client/src/components/merge-tags/MergeTagPicker.jsx

import React from 'react';
import MERGE_TAGS from '../../constants/mergeTags';
import './MergeTagPicker.css';

export default function MergeTagPicker({ onInsert, onClose }) {
  return (
    <div className="merge-tag-picker">
      <div className="merge-tag-header">
        <strong>Insert Merge Tag</strong>
        <button onClick={onClose}>×</button>
      </div>

      <div className="merge-tag-body">
        {Object.entries(MERGE_TAGS).map(([group, tags]) => (
          <div key={group} className="merge-tag-group">
            <div className="merge-tag-group-title">{group}</div>

            {Object.entries(tags).map(([key, tag]) => (
              <div
                key={key}
                className="merge-tag-item"
                onClick={() => onInsert(tag.value)}
              >
                {tag.name}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
